module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Bold.17b55fc.woff2";